export const API_URL = 'incidentTypes'
export const ROUTE_NAME = 'incidentTypes'
